var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRelievedOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9243",
    "data-name": "Group 9243",
    transform: "translate(-14259 -9096)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1803",
    "data-name": "Ellipse 1803",
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(14259 9096)",
    fill: "#d34a7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "directions-run",
    d: "M19.429,7.277a3.646,3.646,0,0,1-2.611-1.07A3.437,3.437,0,0,1,15.7,3.638a3.437,3.437,0,0,1,1.113-2.569A3.642,3.642,0,0,1,19.429,0,3.511,3.511,0,0,1,22,1.07a3.5,3.5,0,0,1,1.07,2.569A3.507,3.507,0,0,1,22,6.208a3.507,3.507,0,0,1-2.569,1.07ZM12.794,32.618.038,30.135a4.124,4.124,0,0,1-.362-2.118A2.965,2.965,0,0,1,.808,26.454l8.9,1.8,2.911-14.81L9.37,14.726v6.25a4.738,4.738,0,0,1-1.884.507,4.124,4.124,0,0,1-1.8-.507s-1.022-7.3,0-8.562,9.5-4.024,9.5-4.024a4.342,4.342,0,0,0,.727-.086,4.342,4.342,0,0,1,.727-.086,3.585,3.585,0,0,1,3.082,1.8l1.884,2.911a8.367,8.367,0,0,0,3.21,3.168,9.056,9.056,0,0,0,4.58,1.2s1.05.736,1.05,1.656a3.89,3.89,0,0,1-1.05,2.025,12.68,12.68,0,0,1-10.017-4.537l-1.113,5.48,3.852,3.6v13.7a3.5,3.5,0,0,1-1.861.79,3.3,3.3,0,0,1-1.82-.79V28.252l-3.767-3.6Z",
    transform: "translate(14272.365 9104)",
    fill: "#f5f5f5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelievedOn);
export default __webpack_public_path__ + "static/media/relieved-on.81e106a116ee80db4bc65142120096e7.svg";
export { ForwardRef as ReactComponent };